import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=7559fa17&scoped=true&"
import script from "./admin.ts?vue&type=script&lang=ts&"
export * from "./admin.ts?vue&type=script&lang=ts&"
import style0 from "./admin.scss?vue&type=style&index=0&id=7559fa17&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7559fa17",
  null
  
)

export default component.exports